import { TextAlignList } from './text-align-list';

export const menuAlignConfiguration = [
    {
        value: TextAlignList.list[0],
        matIcon: 'format_align_left',
        label: 'se-ui-text-editor_cmd_align_left_tooltip'
    }, {
        value: TextAlignList.list[1],
        matIcon: 'format_align_center',
        label: 'se-ui-text-editor_cmd_align_center_tooltip'
    }, {
        value: TextAlignList.list[2],
        matIcon: 'format_align_right',
        label: 'se-ui-text-editor_cmd_align_right_tooltip'
    }, {
        value: TextAlignList.list[3],
        matIcon: 'format_align_justify',
        label: 'se-ui-text-editor_cmd_align_justify_tooltip'
    }
];
